/**
 * Identidad de una fila de match, para detectar la MISMA conciliación repetida.
 * `matchId` es la llave real; los matches viejos no lo traen, así que se cae a
 * contraparte + monto.
 */
export const matchRowKey = (m) => {
  if (m?.matchId) return `mid:${String(m.matchId)}`;
  const entityId = m?.id ?? m?.docId ?? m?.settleId;
  const amount = m?.matchedAmount ?? m?.amount;
  return `ent:${String(entityId ?? "")}|${String(amount ?? "")}`;
};

/**
 * Un match mutual (pago en efectivo / "Rendición por *" / NC↔FC) queda escrito en
 * `inMatch` **y** en `outMatch` del mismo documento: `generateDocumentMatch` corre
 * `match(doc, …, true)` y `match(doc, …, false)` sobre ambos lados para bajar
 * `remaining` en los dos. Concatenar los dos arrays mostraría esa única conciliación
 * como dos filas (y la contaría dos veces en el tab).
 *
 * Se conservan todas las filas de `inMatch` y se descartan de `outMatch` solo las que
 * ya aparecen en `inMatch`. Duplicados DENTRO de un mismo array se respetan: esos sí
 * son matches parciales distintos.
 */
export const mergeDocumentMatchRows = (inRows, outRows) => {
  const ins = Array.isArray(inRows) ? inRows : [];
  const outs = Array.isArray(outRows) ? outRows : [];
  const seen = new Set(ins.map(matchRowKey));
  return [...ins, ...outs.filter((m) => !seen.has(matchRowKey(m)))];
};

/**
 * Cantidad de conciliaciones reales de un documento (`meta.matchs`), sin contar dos veces
 * el match mutual que queda escrito en `inMatch` y en `outMatch`. Es el número que va en
 * el tab "Matchs (N)"; tiene que coincidir con las filas que arma `mergeDocumentMatchRows`.
 */
export const countDocumentMatchRows = (matchs) =>
  mergeDocumentMatchRows(matchs?.inMatch, matchs?.outMatch).length;
